import { gate } from 'hub-http/gates';
import { isConfigReport, isUnifiedEventsReport } from 'reporting-data/tsTypes/reportTypes';
import { isSearchReport } from 'reporting-data/report/configReportGetters';
import { useContext } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { useCrmObjectTableReportComponent } from './CrmObjectTableReportComponentContext';
export const useIsCrmObjectTableSupported = ({
  previewReport
}) => {
  const userInfo = useContext(UserInfoContext);
  const maybeCrmObjectTableComponent = useCrmObjectTableReportComponent();

  //If there is some app that we have not updated to include ProvideCrmObjectTableReportComponent, we should fall back to what exists today.
  //This is to be expected in early development, but eventually we will want to change this to an error that we be alerted on.
  if (!maybeCrmObjectTableComponent) {
    return false;
  }
  if (!userInfo || !userInfo.gates.includes(gate('CRM:Grid:CrmObjectTableInReports'))) {
    return false;
  }
  if (!isConfigReport(previewReport)) {
    return false;
  }
  if (!isSearchReport(previewReport)) {
    return false;
  }
  if (isUnifiedEventsReport(previewReport)) {
    return false;
  }
  return true;
};